<template>
  <div class="d-flex align-center">
    <div v-if="temperature !== undefined" class="d-flex align-center">
      <svg
        :width="20 * scale"
        :height="40 * scale"
        :viewBox="'0 0 20 40'"
        class="mr-3"
      >
        <!-- Thermometer outline -->
        <rect
          x="6"
          y="5"
          width="8"
          height="30"
          rx="4"
          fill="none"
          :stroke="temperatureColor"
          stroke-width="2"
        />
        <!-- Bulb circle -->
        <circle
          cx="10"
          cy="32"
          r="6"
          fill="none"
          :stroke="temperatureColor"
          stroke-width="2"
        />
        <!-- Temperature fill -->
        <rect
          x="8"
          :y="temperatureFillY"
          width="4"
          :height="temperatureFillHeight"
          :fill="temperatureColor"
          rx="2"
          class="temperature-fill"
        />
        <circle
          cx="10"
          cy="32"
          r="4"
          :fill="temperatureColor"
          class="temperature-fill"
        />
      </svg>
      <div v-if="showText" class="d-flex align-center">
        <span class="text-h4 font-weight-bold mr-2"
          >{{ animatedTemperature }}°</span
        >
        <span
          class="text-caption grey--text"
          v-if="$route.fullPath.includes('device')"
          >Temperature</span
        >
      </div>
    </div>
    <div v-else class="text-center">Loading temperature data...</div>
  </div>
</template>

<script>
export default {
  name: "TemperatureIndicator",
  data() {
    return {
      animatedTemperature: 0,
      timer: null,
    };
  },
  props: {
    temperature: {
      type: Number,
      default: 0,
    },
    scale: {
      type: Number,
      default: 1,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    animate: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    temperature: {
      immediate: true,
      handler(newVal) {
        if (this.animate) {
          const start = this.animatedTemperature;
          const end = newVal;
          this.animateValue(start, end, 1000);
        } else {
          this.animatedTemperature = newVal;
        }
      },
    },
  },
  methods: {
    animateValue(start, end, duration) {
      if (start === end) return;

      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      const range = Math.abs(end - start);
      let current = start;
      const increment = end > start ? 1 : -1;
      const stepTime = Math.max(Math.floor(duration / range), 10);

      this.timer = setInterval(() => {
        current += increment;
        this.animatedTemperature = current;
        if (current >= end) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, stepTime);
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  computed: {
    temperatureFillHeight() {
      return (Math.min(Math.max(this.animatedTemperature, 0), 100) / 100) * 25;
    },
    temperatureFillY() {
      return 32 - this.temperatureFillHeight;
    },
    temperatureColor() {
      if (this.animatedTemperature >= 80) return "#EF5350"; // Red for hot
      if (this.animatedTemperature >= 50) return "#FFEB3B"; // Yellow for warm
      return "#2196F3"; // Blue for cool
    },
  },
};
</script>

<style scoped>
.temperature-fill {
  transition: height 1s ease-in-out, y 1s ease-in-out, fill 1s ease-in-out;
}
</style>
